module.exports = __webpack_public_path__ + "static/media/SRPB77_02.c4267107.png";